import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListServiceOrders extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/service-orders/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Number',
        dataIndex: 'number'
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { serviceOrders } = this.props

    const data = serviceOrders.map((serviceOrders, index) => {
      // format date from db
      serviceOrders.created_date = moment(new Date(serviceOrders.created_date)).format('YYYY-MM-DD')
      const returnObj = Object.assign(
        {
          key: `${serviceOrders.id}${index}`,
          job: {
            job_id: serviceOrders.job_id,
            job_type: serviceOrders.job_type,
            id: serviceOrders.id
          }
        },
        serviceOrders
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Service Orders</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListServiceOrders



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListServiceOrders.js